/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../banklin/external/external_system';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RequestContext": {
                "fields": {
                  "externalSystem": {
                    "type": ".squareup.banklin.external.ExternalSystem",
                    "id": 1,
                    "rule": "optional"
                  },
                  "externalSystemId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "balanceToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "customerToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "TransactionResult": {
                "values": {
                  "TR_DO_NOT_USE": 0,
                  "SUCCESS": 1,
                  "TRANSACTION_NOT_FOUND": 2,
                  "INSUFFICIENT_BALANCE": 3,
                  "INVALID_AMOUNT": 4,
                  "DUPLICATE_REQUEST": 5,
                  "SYSTEM_ERROR": 6
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RequestContext && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.TransactionResult) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RequestContext @ squareup/corporate_card/service/dispute_ledger_common.proto at 9:1
 */
export const RequestContext = $root.lookupType('squareup.corporate_card.service.RequestContext');
fixType(RequestContext, {
  externalSystem: {
    notEmpty: true
  },
  externalSystemId: {
    notEmpty: true
  },
  balanceToken: {
    notEmpty: true
  },
  customerToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RequestContext);
/**
 * SOURCE TransactionResult @ squareup/corporate_card/service/dispute_ledger_common.proto at 31:1
 */
export const TransactionResult = $root.lookupEnum('squareup.corporate_card.service.TransactionResult').values;